import React, { useState } from "react"
import Carousel from "nuka-carousel"
import data from "data/play/start-playing"
import Lottie from "react-lottie"
import animationData from "resources/animations/data.json"
import styled from "styled-components"
import { Box, Grid, Typography } from "@material-ui/core"
import TriangleImage from "resources/assets/triangle.svg"

const StyledSlider = styled.div`
  padding: 24px 20px;
`

const StyledDiv = styled.div`
  .animation {
    position: relative;
  }
  @-moz-document url-prefix() {
    .triangle {
      position: absolute;
      bottom: 14px !important;
      left: 0px !important;
      right: 0;
      width: 100% !important;
    }
  }
  .triangle {
    position: absolute;
    bottom: 14px;
    left: 0;
    width: auto;
    max-height: 300px;
  }

  .counter {
    color: #fff;
    background-color: #0cb775;
    text-align: center;
    border-radius: 50%;
    width: 40px;
    padding: 6px;
    height: 40px;
    align-self: center;
    margin-top: 40px;
  }
`

const Animation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  }

  return (
    <div>
      <Lottie options={defaultOptions} height={400} />
    </div>
  )
}

const MobileStartPlaying = () => {
  const [getSelectedStep, setSelectedStep] = useState(1)

  const intervals = [0, 4166, 10450, 19540, 10750]

  function getBottomCarousal() {
    return (
      <Carousel
        // width={"18.29vw"}
        autoplay={true}
        withoutControls={true}
        wrapAround={true}
        swiping={false}
        autoplayInterval={intervals[getSelectedStep]}
        dragging={false}
        pauseOnHover={false}
        speed={500}
        slideIndex={getSelectedStep - 1}
        beforeSlide={slideIndex => {
          let switchItem = 1
          if (slideIndex === 0) {
            switchItem = 2
          } else if (slideIndex === 1) {
            switchItem = 3
          } else if (slideIndex === 2) {
            switchItem = 1
          }

          setSelectedStep(switchItem)
        }}
      >
        {getBottomCarousalData()}
      </Carousel>
    )
  }

  function getBottomCarousalData() {
    let viewArray: JSX.Element[] = []
    data.easyToStartPlayingData.map((item, index) => {
      viewArray[index] = (
        <StyledSlider key={index}>
          <Grid container direction="column" justify="center">
            <Grid item xs>
              <Typography variant="h2" align="center">
                {item.title}
              </Typography>
            </Grid>
            <Box my={1} />
            <Grid item xs>
              <Typography variant="h5" align="center">
                {item.description}
              </Typography>
            </Grid>
          </Grid>
        </StyledSlider>
      )
    })
    return viewArray
  }

  function getParentView() {
    return (
      <StyledDiv>
        {" "}
        <Box my={2} />
        <Grid
          container
          direction="column"
          justify="center"
          alignContent="center"
        >
          <Typography variant="h2" align="center">
            Easy to start playing
          </Typography>
          <Box my={1} />
          <Grid item xs>
            <div className="animation">
              <img
                src={TriangleImage}
                className="triangle"
                alt="yellow triangle with dots"
                loading="lazy"
              />
              <Animation />
            </div>
          </Grid>

          <Typography variant="h2" className="counter" align="center">
            {getSelectedStep}
          </Typography>

          {getBottomCarousal()}
        </Grid>
      </StyledDiv>
    )
  }

  return <div>{getParentView()}</div>
}

export default MobileStartPlaying
